import Data from './data';

export default Data;
